import React from "react";
import { Phone, Mail } from "lucide-react";
import { SITE_INFO } from "../config/site";

export const TopBar = () => (
  <div className="bg-[#040813]/90 backdrop-blur-sm border-b border-white/5 text-[13px] sm:text-[15px] font-medium text-slate-200" data-testid="top-info-bar">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-2 sm:py-3 flex flex-col sm:flex-row items-center sm:justify-between gap-y-1">
      <span className="font-mono tracking-wide" data-testid="topbar-kvk">KVK: {SITE_INFO.kvk}</span>
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 max-w-full">
        <a href={`tel:${SITE_INFO.phoneTel}`} className="hover:text-white font-mono inline-flex items-center gap-2 transition-colors whitespace-nowrap" data-testid="topbar-phone">
          <Phone size={17} className="text-cyan-300 w-[15px] h-[15px] sm:w-[17px] sm:h-[17px] shrink-0" />{SITE_INFO.phone}
        </a>
        <span className="hidden sm:inline text-slate-500" aria-hidden="true">|</span>
        <a href={`mailto:${SITE_INFO.email}`} className="hover:text-white inline-flex items-center gap-2 transition-colors break-all" data-testid="topbar-email">
          <Mail size={17} className="text-cyan-300 w-[15px] h-[15px] sm:w-[17px] sm:h-[17px] shrink-0" />{SITE_INFO.email}
        </a>
      </div>
    </div>
  </div>
);
